import React, { FC, memo } from 'react'
import NewsTickerLine, { NewsTickerLineProps } from '@sport1/news-styleguide/NewsTickerLine'
import Link, { LinkProps } from 'next/link'
import useCurrentDeviceSize from '../../hooks/useCurrentDeviceSize'

type WrappedNewsTickerLineProps = NewsTickerLineProps & LinkProps

const WrappedNewsTickerLine: FC<WrappedNewsTickerLineProps> = ({ href, webRel, ...rest }) => {
    const { deviceSizeDesktop } = useCurrentDeviceSize()

    return (
        <Link href={href} rel={webRel?.(href)}>
            <NewsTickerLine {...rest} onPress={() => {}} hasBorder={deviceSizeDesktop} />
        </Link>
    )
}

export default memo(WrappedNewsTickerLine)
